import React, { useState } from 'react';
import { ChromePicker } from 'react-color';

function CastColor(props: any) {
    const [pickerState, setPickerState] = useState([false, false, false, false, false]);
    
    const handleDisplayPicker = (index: number) => {
        const newState = [...pickerState];
        newState[index] = !newState[index];
        // Close others
        for(let i=0; i<newState.length; i++) {
             if(i!==index) newState[i] = false;
        }
        setPickerState(newState);
    }

    const handleColorChange = (color: any, index:number) => {
        let tmpColor = 'rgb('+color.rgb.r+','+color.rgb.g+','+color.rgb.b+')';
        let newcolors = [...props.colors];
        newcolors[index] = tmpColor;
        props.updateColors(newcolors);
    };

    return (
        <div className="flex justify-center py-2">
            {[3, 1, 0, 2, 4].map((castIndex) => (
                <div key={castIndex} className="relative mx-2 flex flex-col items-center">
                    <button 
                        className="w-5 h-5 rounded border border-gray-300 shadow-sm cursor-pointer" 
                        style={{ backgroundColor: props.colors[castIndex] }} 
                        onClick={() => handleDisplayPicker(castIndex)} 
                    />
                    <span className="text-[10px] text-gray-500 mt-1">
                        {castIndex === 0 ? "1st" : castIndex === 1 ? "2nd" : castIndex === 2 ? "3rd" : castIndex + 1 + "th"}
                    </span>
                    
                    {pickerState[castIndex] && (
                        <div className="absolute top-10 z-50" style={{ left: '50%', transform: 'translateX(-50%)' }}>
                            <div className="fixed inset-0 z-40" onClick={() => {
                                const ns = [...pickerState]; 
                                ns[castIndex] = false; 
                                setPickerState(ns);
                            }}/>
                            <div className="relative z-50">
                                <ChromePicker 
                                    disableAlpha={true} 
                                    color={props.colors[castIndex]} 
                                    onChangeComplete={(color: any)=>handleColorChange(color, castIndex)}
                                />
                            </div>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
}

export default CastColor;